import { RefreshCw } from 'lucide-react';

interface RefreshWidgetProps {
  intervalSeconds: number;
  refreshing: boolean;
  onRefresh: () => void;
  lastRefreshAt?: Date | null;
  disabled?: boolean;
}

export function RefreshWidget({
  refreshing,
  onRefresh,
  lastRefreshAt,
  disabled = false,
}: RefreshWidgetProps) {
  return (
    <div className="inline-flex flex-col items-center">
      <button
        type="button"
        onClick={onRefresh}
        disabled={disabled || refreshing}
        title="Actualiser maintenant"
        aria-label="Actualiser maintenant"
        className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-primary-600 shadow-sm transition-colors hover:bg-primary-50 hover:border-primary-200 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <RefreshCw
          className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`}
        />
        <span>{refreshing ? 'Actualisation...' : 'Actualiser'}</span>
      </button>

      <span className="mt-1 text-[11px] text-gray-400">
        {lastRefreshAt
          ? `Mise à jour à ${lastRefreshAt.toLocaleTimeString('fr-FR', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            })}`
          : 'Mise à jour à —'}
      </span>
    </div>
  );
}
